import { CreateContentTypes } from './course/types'

export let MIN_BUTTON_SIZE = 44

export let iconSx = {
  minWidth: MIN_BUTTON_SIZE,
  minHeight: MIN_BUTTON_SIZE,
}

export let paperInputSx = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'background.paperDark',
    '&.Mui-disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
  '& .MuiSelect-select': {
    backgroundColor: 'background.paperDark',
  },
  '&.Mui-disabled': {
    opacity: 0.5,
  },
}

export let modalFieldSx = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'background.paperDark',
  },
  '& .MuiInputBase-input': {
    backgroundColor: 'background.paperDark',
  },
}

let CREATE_V5_BASE = '/create/v5'

export let CREATE_COURSE_URLS = {
  V4INDEX: '/create/v4/course',
  INDEX: `${CREATE_V5_BASE}/course`,
  CREATE: `${CREATE_V5_BASE}/course/create`,
  EDIT: (courseID: string) => `${CREATE_V5_BASE}/course/${courseID}/edit`,
}

export let CREATE_SHOW_NOTES_URLS = {
  LIBRARY: `${CREATE_V5_BASE}/show-notes-library`,
  EDIT: (id: string) => `${CREATE_V5_BASE}/show-notes/${id}`,
}

export let CREATE_QUIZ_URLS = {
  LIBRARY: `${CREATE_V5_BASE}/quiz-library`,
  EDIT: (id: string) => `${CREATE_V5_BASE}/quiz/${id}`,
}

export let CREATE_VIDEO_URLS = {
  LIBRARY: `${CREATE_V5_BASE}/video-library`,
}

export let CREATE_SERIES_URLS = {
  INDEX: `${CREATE_V5_BASE}/series`,
  CREATE: `${CREATE_V5_BASE}/series/create`,
  EDIT: (seriesID: string) => `${CREATE_V5_BASE}/series/${seriesID}/edit`,
}

export let CREATE_COURSE_V3_API_URL = '/api/v3/create/course'
export let CREATE_MIGRATE_API_URL = '/api/create/migrate'
export let CREATE_STREAM_V3_API_URL = '/api/v3/create/stream'
export let CREATE_SYLLABUS_API_URL = '/api/create/syllabus'
export let CREATE_CATEGORY_API_URL = '/api/v3/create/section'
export let CREATE_TEMPLATE_API_URL = '/api/v3/create/template'
export let CREATE_VIDEO_API_URL = '/api/v3/create/video'
export let CREATE_SHOW_NOTES_API_URL = '/api/v3/create/show-notes'
export let CREATE_QUIZ_API_URL = '/api/v3/create/quiz'
export let CREATE_ACCREDITATIONS_API_URL = '/api/v3/create/accreditation'
export let CREATE_INSTRUCTOR_API_URL = '/api/v3/create/instructor'
export let CREATE_SERIES_API_URL = '/api/v3/create/series'

export let contentTypeApiUrlMap: Map<CreateContentTypes, string> = new Map([
  ['quiz', CREATE_QUIZ_API_URL],
  ['showNotes', CREATE_SHOW_NOTES_API_URL],
  ['video', CREATE_VIDEO_API_URL],
])

export let contentTypeToTextMap: Map<CreateContentTypes, string> = new Map([
  ['quiz', 'Quiz'],
  ['showNotes', 'Show Notes'],
  ['video', 'Video'],
])
